import { useLiveStatus } from "../lib/realtime-context.js";
import type { LiveStatus } from "../lib/realtime-context.js";
import "./status-mark.css";

/**
 * A person's custom status beside their name: the emoji, and a small "DND"
 * tag while they have notifications snoozed. Renders nothing for nobody with
 * either, so it can sit unconditionally next to every name.
 *
 * `fetched` is what the page loaded with; a live `status` frame overrides it.
 */
export function StatusMark({
  userId,
  fetched,
  showText = false,
}: {
  userId: string | undefined;
  fetched: LiveStatus | null | undefined;
  /** Also spell the status text out (people list, profile) rather than only on hover. */
  showText?: boolean;
}) {
  const status = useLiveStatus(userId, fetched);
  if (!status) return null;
  const title = [status.emoji, status.text, status.dnd ? "Do Not Disturb" : null].filter(Boolean).join(" · ");
  return (
    <span className="status-mark" title={title}>
      {status.emoji && (
        <span className="status-mark__emoji" role="img" aria-label={status.text ?? "Status"}>
          {status.emoji}
        </span>
      )}
      {showText && status.text && <span className="status-mark__text">{status.text}</span>}
      {status.dnd && <span className="status-mark__dnd">DND</span>}
    </span>
  );
}
